import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "担当課一覧")
], -1)
const _hoisted_3 = { class: "d-grid d-md-flex justify-content-md-end" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新規登録")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("インポート")
const _hoisted_6 = { class: "table table-hover table-bordered" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "担当課コード"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "担当課名"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "所在地1"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "所在地2"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "電話番号"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      style: {"width":"60px"}
    }, "編集")
  ])
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center"
}, "担当課が登録されていません。", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "d-grid d-md-flex justify-content-md-center" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("戻る")

import { ref } from 'vue'
import { useNicotto, ConciergeDepartment } from '@/plugins/nicotto'
import IconPenToSquare from '@/components/ui/IconPenToSquare.vue'
import ButtonLink from "@/components/ui/ButtonLink.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexView',
  setup(__props) {

const nicotto = useNicotto()
const departments = ref<ConciergeDepartment[]>([])
nicotto.concierge.getDepartmentList()
  .then(data => {
    departments.value = data
  })

const exportCsv = async() => {
  const linkUrl = window.URL.createObjectURL(await nicotto.concierge.getDepartmentCsv())
  const link = document.createElement('a')
  link.href = linkUrl
  link.download = '担当課一覧.csv'
  link.click()
  window.URL.revokeObjectURL(linkUrl)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ButtonLink, {
        to: "/concierge/departments/new",
        class: "btn btn-primary mx-2 mb-2"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(ButtonLink, {
        to: "/concierge/departments/import",
        class: "btn btn-primary mx-2 mb-2"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        class: "btn btn-primary mx-2 mb-2",
        onClick: exportCsv
      }, "エクスポート")
    ]),
    _createElementVNode("table", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(departments.value, (department) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: department.code
          }, [
            _createElementVNode("td", null, _toDisplayString(department.code), 1),
            _createElementVNode("td", null, _toDisplayString(department.name), 1),
            _createElementVNode("td", null, _toDisplayString(department.locations && department.locations.at(0)), 1),
            _createElementVNode("td", null, _toDisplayString(department.locations && department.locations.at(1)), 1),
            _createElementVNode("td", null, _toDisplayString(department.tel), 1),
            _createElementVNode("td", null, [
              _createVNode(ButtonLink, {
                class: "btn-primary",
                to: `/concierge/departments/${department.code}`,
                title: "編集"
              }, {
                default: _withCtx(() => [
                  _createVNode(IconPenToSquare)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]))
        }), 128)),
        (departments.value.length == 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _hoisted_10))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(ButtonLink, {
        class: "btn-secondary mx-2 mb-2",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      })
    ])
  ]))
}
}

})